import { useEffect } from "react";
import InspirationGallery from "../inspiration-gallery";
import { useDispatch, useSelector } from "react-redux";
import { clearImageList, getInspirationGalleryById } from "../store/inspirationGallery/inspiration-gallery-slice";
import { useNavigate, useParams } from "react-router-dom";
import HeroBanner from "../feature-banner";
import { Spin } from "antd";
import "../css/inspiration-gallery-layout.css";

const InspirationDetailView = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const { id } = useParams();

    const {
        inspirationGalleryDetails,
        inspirationGalleryImageList,
        isLoading,
        isImageNext,
    } = useSelector((state) => state.inspirationGallerySlice);

    useEffect(() => {
        if (id) {
            dispatch(getInspirationGalleryById(id));
            dispatch(clearImageList());
        }
    }, [id, dispatch]);

    const imageCount = inspirationGalleryImageList?.length ?? 0;

    return (
        <Spin spinning={isLoading} size="large">
            <div className="inspiration-detail-page container">
                <HeroBanner data={inspirationGalleryDetails} onBack={() => navigate(-1)} />
                <section className="inspiration-detail-gallery-shell">
                    <div className="inspiration-detail-section-head">
                        <h2>Screenshots</h2>
                        {imageCount > 0 && (
                            <span className="inspiration-detail-section-count">
                                {imageCount} image{imageCount === 1 ? "" : "s"} in view
                                {isImageNext ? " · Scroll for more" : ""}
                            </span>
                        )}
                    </div>
                    <InspirationGallery images={inspirationGalleryImageList || []} />
                </section>
            </div>
        </Spin>
    );
};

export default InspirationDetailView;
